/**
 * Zentrale Route-Registry für den Auto-Scanner.
 */

export interface RouteDefinition {
  path: string;
  slug: string;
  title: string;
  /** "post" = WP-Beitrag (z. B. Suiten), wird vom Seiten-Scanner ausgeschlossen. Default: "page". */
  kind?: "page" | "post";
}

export const ROUTE_DEFINITIONS: RouteDefinition[] = [
  { path: "/", slug: "startseite", title: "Startseite" },
  { path: "/suites", slug: "suites", title: "Unsere Suites" },
  { path: "/suites/deluxe-suite", slug: "deluxe-suite", title: "Deluxe-Suite", kind: "post" },
  { path: "/suites/swiss-suite", slug: "swiss-suite", title: "Swiss-Suite", kind: "post" },
  { path: "/suites/garten-suite", slug: "garten-suite", title: "Garten-Suite", kind: "post" },
  { path: "/suites/austria-suite", slug: "austria-suite", title: "Austria-Suite", kind: "post" },
  { path: "/lerch-plus", slug: "lerch-plus", title: "Lerch Plus" },
  { path: "/wellness", slug: "wellness", title: "Wellness" },
  { path: "/erlebnisse", slug: "erlebnisse", title: "Erlebnisse" },
  { path: "/erlebnisse/sommer", slug: "erlebnisse-sommer", title: "Sommer in Kappl & Paznaun" },
  { path: "/erlebnisse/winter", slug: "erlebnisse-winter", title: "Winter in Kappl & Paznaun" },
  { path: "/erlebnisse/top-events", slug: "erlebnisse-top-events", title: "Top Events" },
  { path: "/bewertungen", slug: "bewertungen", title: "Alle Bewertungen" },
  { path: "/buchen", slug: "buchen", title: "Buchen" },
  { path: "/anfrage", slug: "anfrage", title: "Anfrage" },
  { path: "/lage-anreise", slug: "lage-anreise", title: "Lage & Anreise" },
  { path: "/impressum", slug: "impressum", title: "Impressum" },
  { path: "/datenschutz", slug: "datenschutz", title: "Datenschutz" },
  { path: "/barrierefreiheit", slug: "barrierefreiheit", title: "Barrierefreiheit" },
  { path: "/sitemap", slug: "sitemap", title: "Sitemap" },
];
